<div #overlay class="overlay">
    <!-- <button #closeButton (click)="closeModal($event)" class="close-button">
        <span aria-hidden="true">X</span>
    </button> -->
    <div class="modal-container">
        <ng-template appModalContent></ng-template>
    </div>
</div>